import type { MaintenanceStory } from "../utils/maintenance";
import { parseMaintenance } from "../utils/maintenance";
import { useLocaleCopyStore } from "./useLocaleCopyStore";

type MaintenanceHookState = {
  maintenance: MaintenanceStory | undefined;
  isLoadingMaintenance: boolean;
  maintenanceCloseActions: {
    title?: string;
    subtitle?: string;
  };
};

export function useMaintenanceStory(): MaintenanceHookState {
  const localeCopy = useLocaleCopyStore(state => state.localeCopy);
  const isLoadingLocaleCopy = useLocaleCopyStore(state => state.isLoadingLocaleCopy);

  const maintenancePageValue = localeCopy?.shared?.maintenancePage;
  const maintenanceCloseActions = {
    title: localeCopy?.shared?.maintenanceCloseActionTitle,
    subtitle: localeCopy?.shared?.maintenanceCloseActionSubtitle,
  };
  const maintenance = maintenancePageValue ? parseMaintenance(maintenancePageValue) : undefined;

  return {
    maintenance,
    maintenanceCloseActions,
    isLoadingMaintenance: isLoadingLocaleCopy,
  };
};
